export const getCurrentYear = () => new Date().getFullYear().toString();

const renderCurrentYears = ({ dot }: any) => ` ${getCurrentYear()}${dot ? '. ' : ' '}`;

export default renderCurrentYears;
